export default __webpack_public_path__ + "static/media/award1.dec958da.png";